import { GameVars } from "../GameVars";

export class Hooligan extends Phaser.Group {

    public static MALE_WITH_HAIR = 0;
    public static FEMALE = 1;
    public static MALE_BOLD = 2;

    private initial_py: number;

    constructor(game: Phaser.Game, px: number, py: number, type: number, teamColor: number, race: number, scaled?: boolean, inverted?: boolean) {

        super(game, null, "hooligan", false);

        this.scale.y = GameVars.scaleY;
        this.x = px;
        this.y = py;
        this.initial_py = py;

        let skinTextureName: string;
        let teamTextureName: string;
        let shapeTextureName: string;

        switch (type) {

            case Hooligan.MALE_WITH_HAIR:
                skinTextureName = "hooligan_1_skin";
                teamTextureName = "hooligan_1_team_colours";
                shapeTextureName = "hooligan_1_solid";
                break;
            case Hooligan.FEMALE:
                skinTextureName = "hooligan_2_skin";
                teamTextureName = "hooligan_2_team_colours";
                shapeTextureName = "hooligan_2_solid";
                break;
            case Hooligan.MALE_BOLD:
                skinTextureName = "hooligan_3_skin";
                teamTextureName = "hooligan_3_team_colours";
                shapeTextureName = "hooligan_3_solid";
                break;
            default:
        }

        let raceColor: number;

        switch (race) {
            case 1:
                // blanco
                raceColor = 0xFFA860;
                break;
            case 2:
                // negro
                raceColor = 0x6B3F26;
                break;
            case 3:
                // latino
                raceColor = 0xDB945C;
                break;
            case 4:
                // mulato
                raceColor = 0xB68651;
                break;
            case 5:
                // asiatico
                raceColor = 0xECBB72;
                break;
            default:
        }

        let skin = this.create(0, 0, "texture_atlas_5", skinTextureName);
        skin.tint = raceColor;

        let teamColours = this.create(0, 0, "texture_atlas_5", teamTextureName);
        teamColours.tint = teamColor;

        let shape = this.create(0, 0, "texture_atlas_5", shapeTextureName);

        let scaleFactor = scaled ? .7 : 1;
        let invertedFactor = inverted ? -1 : 1;

        skin.scale.setTo(scaleFactor * invertedFactor, scaleFactor);
        teamColours.scale.setTo(scaleFactor * invertedFactor, scaleFactor);
        shape.scale.setTo(scaleFactor * invertedFactor, scaleFactor);

        this.game.time.events.add(Math.random() * 1500, function (): void {
            let pulseTween: Phaser.Tween = this.game.add.tween(this);
            pulseTween.to({ y: this.initial_py - 12 }, 150, Phaser.Easing.Cubic.Out, false);
            pulseTween.to({ y: this.initial_py }, 150, Phaser.Easing.Bounce.Out);
            pulseTween.delay(150);
            pulseTween.loop();
            pulseTween.start();
        }, this);
    }
}
